export const CF_ALL_ACCESS_MONTHLY_PRODUCT_ID = 246_178
export const CF_ALL_ACCESS_YEARLY_PRODUCT_ID = 60_189_699

export const MD_ALL_ACCESS_MONTHLY_PRODUCT_ID = 2189
export const MD_ALL_ACCESS_YEARLY_PRODUCT_ID = 2196
